import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import DividerLine from "src/components/common/DividerLine";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { INetElectricityProps } from "./interfaces";

export default class NetElectricity extends Component<INetElectricityProps, IBaseState> {
  public constructor(props: any) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Net Electricity</legend>
          <LoadingStatus width={25} height={25} singular={true} />
        </fieldset>
      );
    }

    const xsLabelWidthR = 6;
    const xsInputWidthR = 6;
    const smLabelWidthR = 5;
    const smInputWidthR = 7;
    const mdLabelWidthR = 6;
    const mdInputWidthR = 6;

    let netElectricity = this.props.gridUsage - this.props.solarReceived;
    if (netElectricity < 0) {
      netElectricity = 0;
    }

    return (
      <fieldset className="fieldset-right">
        <legend>Net Electricity</legend>
        <FormGroup bsSize="small" controlId="gridUsage">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Electricity Used
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.gridUsage}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="solarReceived">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Solar Received
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarReceived}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <DividerLine
          xsOffset={xsLabelWidthR}
          xs={xsInputWidthR}
          smOffset={smLabelWidthR}
          sm={smInputWidthR}
          mdOffset={mdLabelWidthR}
          md={mdInputWidthR}
        />
        <FormGroup bsSize="small" controlId="netElectricit">
          <Col
            xs={xsLabelWidthR}
            sm={smLabelWidthR}
            md={mdLabelWidthR}
            componentClass={ControlLabel}
          >
            Net Electricity
          </Col>
          <Col xs={xsInputWidthR} sm={smInputWidthR} md={mdInputWidthR}>
            <FormControl
              bsSize="small"
              type="number"
              value={netElectricity}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/NetElectricity.tsx